import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import OnBoarding from '../pages/OnBoarding';
import Welcome from '../pages/Welcome';
import ConfirmRemittance from '../pages/ConfirmRemittance';
import RequestRemittance from '../pages/RequestRemittance';
import RemittanceDetails from '../pages/RemittanceDetails';
import ChatRoom from '../pages/ChatRoom';
import Chats from '../pages/Chats';
import {TabSwitchProvider} from '../context/tabSwtich';
import AddContact from '../pages/AddContact';
import Info from '../pages/Info';
import Register from '../pages/Register';
import ConfirmRegistry from '../pages/ConfirmRegistry';
import HistoryPage from '../pages/HistoryPage';
import ServiceUnavailable from '../pages/ServiceUnavailable';

export default function WidgetRoutes() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<OnBoarding />}>

          </Route>
          <Route path="/register" element={<Register />}>

          </Route>
          <Route path="/confirm_registry" element={<ConfirmRegistry />}>

          </Route>
          <Route path="/welcome" element={<Welcome />}>

          </Route>
          <Route path="/confirm" element={<ConfirmRemittance />}>

          </Route>
          
          <Route path="/request_remittance" element={
            <TabSwitchProvider>
              <RequestRemittance />
            </TabSwitchProvider>
          }>
         
          {/* <Route path="/request_remittance" element={<ServiceUnavailable />}> */}
          </Route>
          <Route path="/history" element={
            <TabSwitchProvider>
              <HistoryPage />
            </TabSwitchProvider>
          }>
          </Route>
          <Route path="/details" element={<RemittanceDetails />}>

          </Route>
          <Route path="/chat_room" element={
            <TabSwitchProvider>
              <ChatRoom />
            </TabSwitchProvider>
          }>
          </Route>
          <Route path="/chats" element={<Chats />}>

          </Route>
          <Route path="/add_contact" element={<AddContact />}>

          </Route>
          <Route path="/info" element={<Info />}>
          </Route>
        </Routes>
      </div>
    </Router>
  );
}
